import { AppShellLayout } from "@civala/shared-ui"
import { useLocation, useNavigate } from "@tanstack/react-router"
import { type ReactNode, useMemo } from "react"

import { useDemoMode } from "@/hooks/useDemoMode"
import { visibleNavSections } from "@/lib/navigation"

import { PortalTopBarRight } from "./PortalTopBar"

type PortalShellProps = {
  readonly children: ReactNode
}

export function PortalShell({ children }: PortalShellProps) {
  const location = useLocation()
  const navigate = useNavigate()

  // Device-local demo mode (default off): hides sections whose screens are out of date.
  // Hidden routes still resolve by direct URL — this governs the sidebar only.
  const [demoMode] = useDemoMode()
  const sidebarSections = useMemo(() => visibleNavSections(demoMode), [demoMode])

  return (
    <AppShellLayout
      persistKey="portal"
      sidebarSections={sidebarSections}
      sidebarAccordion
      activePath={location.pathname}
      onNavigate={(path) => void navigate({ to: path })}
      brand={{ subtitle: "Portal" }}
      topBar={{
        right: <PortalTopBarRight />,
      }}
      viewTransitionName="portal-content"
    >
      {children}
    </AppShellLayout>
  )
}
